import Vue from 'vue';
import Vuex from 'vuex';
// Vuex.Store({
//   state,
//   actions,
//   mutation
// });
Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    platform: "1", //链接形式：1：PC，2：无线，默认：１
    deposit: 0, // 提币限额
    rate: 0, // 返利比例
    agent: 0, // 代理提成比例
    user: window.localStorage.getItem("userInfo")
      ? JSON.parse(window.localStorage.getItem("userInfo"))
      : {}, // 用户信息
    tbGood: {}, // 淘宝商品详情
    pddGood: {}, // 淘宝商品详情
    jdGood: {} // 淘宝商品详情// 淘宝商品详情
  },
  mutations: {
    // 检查设备
    setPlatform(state, data) {
      state.platform = data;
    },
    // 初始化配置项
    setConfig(state, data) {
      state.deposit = data.deposit;
      state.rate = data.rate;
      state.agent = data.agent;
    },
    // 设置用户信息
    setUser(state, data) {
      state.user = data;
    },
    // 选中淘宝信息
    setTb(state, data) {},
    // 选中拼多多信息
    setPdd(state, data) {},
    // 选中京东信息
    setJd(state, data) {}
  },
  actions: {
    // 检查设备
    setPlatform({ commit }, value) {
      commit("setPlatform", value);
    },
    setConfig({ commit }, data) {
      commit("setConfig", data);
    },
    setUser({ commit }, data) {
      commit("setUser", data);
    }
  }
});



// WEBPACK FOOTER //
// ./src/assets/js/store.js